import React, { createContext, useEffect, useState } from 'react'
const DEFAULT_COLOR ='#008080';
// #008080,#1F6F5F,#005461   
export const AppThemeContext = createContext()
export function AppThemeProvider({ children }) {

    
    const getInitialColor = () => {
        const storedColor = localStorage.getItem('UserTheme');
        return storedColor && storedColor.length > 0 ? storedColor : DEFAULT_COLOR;
    };

    const [PrimaryColor, setPrimaryColor] = useState(getInitialColor);

    useEffect(() => {
        
        const storedColor = localStorage.getItem('UserTheme');
        if (storedColor && storedColor.length > 0) {
            setPrimaryColor(storedColor);
        } else {
            setPrimaryColor(DEFAULT_COLOR);
        }
    }, []);

    return (
        <AppThemeContext.Provider value={{ setPrimaryColor, PrimaryColor }}>
            {children}
        </AppThemeContext.Provider>
    )
}
